import { buildApiUrl } from '../../../../../core/config/api-url.util';

export const ORGANIZATION_ENDPOINTS = {
    dataTable: buildApiUrl(
        'masterAdmin',
        '/v1/tenants/datatable'
    ),

    getById: (id: string) =>
        buildApiUrl(
            'masterAdmin',
            `/v1/tenants/${encodeURIComponent(id)}`
        ),

    autocomplete: buildApiUrl(
        'masterAdmin',
        '/v1/tenants/autocomplete'
    ),

    /** Full wizard record (basics, localization, plan, admin contact) — GET /v1/organizations/{id}. */
    organizationDetails: (id: string) =>
        buildApiUrl(
            'masterAdmin',
            `/v1/organizations/${encodeURIComponent(id)}`
        ),

    /** The organization's timeline — GET /v1/organizations/{id}/history. */
    organizationHistory: (id: string) =>
        buildApiUrl(
            'masterAdmin',
            `/v1/organizations/${encodeURIComponent(id)}/history`
        ),

    /** Companies, users and storage in use against the plan's limits — GET /v1/organizations/{id}/usage. */
    organizationUsage: (id: string) =>
        buildApiUrl(
            'masterAdmin',
            `/v1/organizations/${encodeURIComponent(id)}/usage`
        ),

    /** POST: emails the first administrator a new set-password link. */
    resendInvitation: (id: string) =>
        buildApiUrl(
            'masterAdmin',
            `/v1/organizations/${encodeURIComponent(id)}/resend-invitation`
        ),

    /** POST: emails the organization's administrator a link to choose a new password. */
    resetAdminPassword: (id: string) =>
        buildApiUrl(
            'masterAdmin',
            `/v1/organizations/${encodeURIComponent(id)}/reset-admin-password`
        ),

    /** POST: deletes the organization (body: its name, typed to confirm). */
    deleteOrganization: (id: string) =>
        buildApiUrl(
            'masterAdmin',
            `/v1/organizations/${encodeURIComponent(id)}/delete`
        ),

    dashboard: buildApiUrl(
        'masterAdmin',
        '/v1/organizations/dashboard'
    ),
} as const;
